import common from './locales/tr/common.json';
import errors from './locales/tr/errors.json';
import validation from './locales/tr/validation.json';
import nav from './locales/tr/nav.json';
import app from './locales/tr/app.json';
import components from './locales/tr/components.json';

import analytics from './locales/tr/analytics.json';
import apiKeys from './locales/tr/api-keys.json';
import articles from './locales/tr/articles.json';
import audit from './locales/tr/audit.json';
import branches from './locales/tr/branches.json';
import campaigns from './locales/tr/campaigns.json';
import auth from './locales/tr/auth.json';
import authors from './locales/tr/authors.json';
import categories from './locales/tr/categories.json';
import componentStudio from './locales/tr/component-studio.json';
import dashboard from './locales/tr/dashboard.json';
import forms from './locales/tr/forms.json';
import ipAllowlist from './locales/tr/ip-allowlist.json';
import kvkk from './locales/tr/kvkk.json';
import languages from './locales/tr/languages.json';
import ldap from './locales/tr/ldap.json';
import mePreferences from './locales/tr/me-preferences.json';
import media from './locales/tr/media.json';
import menus from './locales/tr/menus.json';
import notifications from './locales/tr/notifications.json';
import pages from './locales/tr/pages.json';
import profile from './locales/tr/profile.json';
import projects from './locales/tr/projects.json';
import settings from './locales/tr/settings.json';
import smtp from './locales/tr/smtp.json';
import sss from './locales/tr/sss.json';
import tags from './locales/tr/tags.json';
import translations from './locales/tr/translations.json';
import users from './locales/tr/users.json';
import web from './locales/tr/web.json';
import widgets from './locales/tr/widgets.json';
import workflow from './locales/tr/workflow.json';

/**
 * All Turkish namespaces. Namespace key == feature folder name (hyphenated)
 * so `t('app-users:...')` maps 1:1 to `src/features/app-users`.
 */
export const trResources = {
  common,
  errors,
  validation,
  nav,
  app,
  components,
  analytics,
  'api-keys': apiKeys,
  articles,
  audit,
  branches,
  auth,
  campaigns,
  authors,
  categories,
  'component-studio': componentStudio,
  dashboard,
  forms,
  'ip-allowlist': ipAllowlist,
  kvkk,
  languages,
  ldap,
  'me-preferences': mePreferences,
  media,
  menus,
  notifications,
  pages,
  profile,
  projects,
  settings,
  smtp,
  sss,
  tags,
  translations,
  users,
  web,
  widgets,
  workflow,
} as const;

export const resources = { tr: trResources } as const;

export const NAMESPACES = Object.keys(trResources) as Array<keyof typeof trResources>;
